import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function BrandIntroSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about-brand" ref={ref} className="py-24 md:py-32 bg-[#faf8f5]">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left: Text */}
          <div className={`transition-all duration-800 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            {/* Label */}
            <div className="flex items-center gap-3 mb-8">
              <div className="divider-gold w-12"></div>
              <span className="text-[0.8125rem] tracking-[0.2em] text-[#9a8470] font-medium uppercase">About</span>
            </div>

            <h2
              className="font-serif-tc text-[#2c2420] leading-[1.4] mb-8"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              我叫鳴真，<br />
              是一位把古箏<br className="hidden md:block" />
              融入生活裡的老師。
            </h2>

            <p className="text-[1.1875rem] leading-[1.75] text-[#5a4e42] mb-6">
              我不急著讓你學會什麼，也不以成果或速度作為衡量。更在意的是，在學習的過程中，你是否感到安心、穩定，並願意長久地與這個聲音相處。
            </p>

            <p className="text-[1.1875rem] leading-[1.75] text-[#5a4e42] mb-10">
              我相信，音樂不是用來比較或證明自己的。學古箏，可以是一件慢慢來的事。
            </p>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#ede8e0] hover:bg-[#e0d8cc] text-[#5a4a3a] text-[1rem] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              認識鳴箏老師
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>

            {/* Stats */}
            <div className="flex items-start gap-12 mt-14 pt-12 border-t border-[#e8ddd0]">
              <div>
                <p className="text-[2.5rem] font-bold text-[#2c2420] font-serif-tc leading-none mb-2">慢・穩</p>
                <p className="text-[0.875rem] text-[#9a8470] tracking-wide">核心教學節奏</p>
              </div>
              <div>
                <p className="text-[2.5rem] font-bold text-[#2c2420] font-serif-tc leading-none mb-2">陪伴</p>
                <p className="text-[0.875rem] text-[#9a8470] tracking-wide">品牌核心價值</p>
              </div>
            </div>
          </div>

          {/* Right: Image Card */}
          <div
            className={`transition-all duration-800 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            style={{ transitionDelay: '0.2s' }}
          >
            <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '4/5' }}>
              <img
                src="https://storage.helloreaddy.io/project_files/79c1f631-1cb7-456b-a6cf-fdd8ff21e9a0/2d587d2b-d6c1-42bf-a99f-efa35932c012_compressed_G_Image_2yai3y2yai3y2yai.webp"
                alt="鳴箏老師教學"
                className="w-full h-full object-cover object-top"
              />
              {/* Overlay bottom info */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a1410]/70 via-transparent to-transparent"></div>
              <div className="absolute top-5 left-5">
                <span className="px-3 py-1.5 rounded-full bg-white/90 text-[#3a2e22] text-[0.8125rem] font-medium tracking-wide">
                  陪伴式學習
                </span>
              </div>
              <div className="absolute bottom-7 left-7 right-7">
                <p className="text-white/60 text-[0.8125rem] tracking-wide mb-1">鳴箏古箏教學</p>
                <p className="text-white text-[1.125rem] font-medium leading-snug font-serif-tc">
                  讓音樂成為生活的<br />一部分
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
